import React from 'react'
import { SVGProps } from 'react'

const ApartmentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 1a1 1 0 0 0-1 1v13h8V2a1 1 0 0 0-1-1H3Zm1.75 2h1.5v1.5h-1.5V3Zm3 0h1.5v1.5h-1.5V3Zm-3 2.75h1.5v1.5h-1.5v-1.5Zm3 0h1.5v1.5h-1.5v-1.5ZM4.75 8.5h1.5V10h-1.5V8.5Zm3 0h1.5V10h-1.5V8.5Zm-3 2.75h1.5v1.5h-1.5v-1.5Zm3 0h1.5v1.5h-1.5v-1.5Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 5h2a1 1 0 0 1 1 1v9h-3V5Zm1 2h1v1.5h-1V7Zm0 2.75h1v1.5h-1v-1.5Z"
    />
  </svg>
)
export default ApartmentIcon
